import { putpost2 } from "./putPost2";
import { getAPI,getPDF } from "./getApi";
import { putpost } from "./putPost";
import { uploadpost } from "./uploadPost";
import { deleteAPI } from "./deleteApi";
import { validateToken } from "./validateTokenHelper";
import { CURRENT_BUILD_VERSION } from "services/constant";
export { putpost2, getAPI, putpost, uploadpost, deleteAPI, validateToken,getPDF };

const getCurrentBuildVersion = (response) =>
  response && response.headers.get("Build-Version");

export const isVersionBuildUpdated = (response) => {
  // from BE
  const currentVersion = getCurrentBuildVersion(response);
  if (currentVersion && CURRENT_BUILD_VERSION !== currentVersion) {
    window.location.reload();
  }
};
